import React from 'react';
import PropTypes from 'prop-types';

import ServiceAnnouncement from '../../dashboard/serviceAnnouncements/serviceAnnouncement.component';

import { FormikPropTypes } from '../../shared/forms/propTypes';
import { CommunicationTypes } from '../../dashboard/constants';
import { messagePropTypes } from './propTypes';

const getCommunicationToRender = ({ type }) => {
  const componentsToRender = {
    [CommunicationTypes.ANNOUNCEMENT]: ServiceAnnouncement,
  };
  return componentsToRender[type] || null;
};


const CommunicationPreview = ({ formik, value }) => {
  const Communication = getCommunicationToRender({ type: value.type });

  if (!Communication) {
    return (
      <div className="communication-preview">
        <div className="communication-preview-placeholder">
          No preview available
        </div>
      </div>
    );
  }
  if ((value.isEditMode || formik.dirty) && formik.isValid) {
    return (
      <div className="communication-preview">
        <Communication
          message={value}
          showIcons={false}
          truncatable={false}
        />
      </div>
    );
  }
  return (
    <div className="communication-preview">
      <div className="communication-preview-placeholder">
        (Preview will appear here.)
      </div>
    </div>
  );
};

CommunicationPreview.propTypes = {
  formik: FormikPropTypes.isRequired,
  value: PropTypes.shape({
    ...messagePropTypes,
    type: PropTypes.string,
    isEditMode: PropTypes.bool,
  }),
};

export default CommunicationPreview;
